import { PraiseTabs } from './praise.enums';

export const PRAISE_TABS = [
  { value: PraiseTabs.RECEIVED, label: PraiseTabs.RECEIVED },
  { value: PraiseTabs.GIVEN, label: PraiseTabs.GIVEN },
];
